import { Button } from '@codegouvfr/react-dsfr/Button';
import { useSessionContext } from '@common/hooks';
import { DateISO, UtilisateurDto, UtilisateurRole } from '@common/services';
import { DateUtils } from '@common/utils';
import React, { ReactNode, useState } from 'react';
import { Panel } from '../base/Panel';

export const OfaUserPanel = ({ title, user, dateHabilitation, displayJobAndDates, extraUser, onEdit, isFc }: OfaUserPanelProps) => {

  const sessionContext = useSessionContext();

  const [openExtra, setOpenExtra] = useState<boolean>(false);

  const isAdmin =
    isFc ||
    (sessionContext?.role && [UtilisateurRole.ADMIN_1, UtilisateurRole.ADMIN_2].some(role =>
      sessionContext.role.includes(role),
    ));

  const contents: Content[] = [
    { title: 'Nom', value: user.nom },
    { title: 'Prénom', value: user.prenom },
    { title: 'Téléphone', value: user.telephone },
    { title: 'Courriel', value: user.email },
  ];

  const extraContents: Content[] = [
    { title: 'Nom', value: extraUser?.user?.nom },
    { title: 'Prénom', value: extraUser?.user?.prenom },
    {
      title: extraUser?.user?.telephone ? 'Téléphone' : 'Fonction',
      value: extraUser?.user?.telephone ?? extraUser?.user?.travail,
    },
    { title: 'Courriel', value: extraUser?.user?.email },
  ];

  if (displayJobAndDates) {
    contents.push(
      { title: 'Fonction', value: user.travail },
      { title: 'Date habilitation', value: (dateHabilitation) ? DateUtils.formatDateConnexion(dateHabilitation) : '' },
    );
    extraContents.push(
      { title: 'Fonction', value: extraUser?.user?.travail },
      {
        title: 'Date habilitation',
        value: (dateHabilitation) ? DateUtils.formatDateConnexion(dateHabilitation) : '',
      },
    );
  }

  return (
    <Panel title={title}
           subtitle={(displayJobAndDates) ? `Dernière connexion : ${(user.dateConnexion) ? DateUtils.formatDateConnexion(user.dateConnexion) : 'inconnue'}` : ''}
           cornerButton={isAdmin ? {
             iconId: 'fr-icon-edit-fill',
             onClick: () => onEdit(),
           } : undefined}>

      <div className={'flex flex-col gap-6'}>

        <div className={'mt-4 grid grid-cols-3 gap-4'}>
          {contents.map(({ title, value }, index) => (
            <div key={`${index}-${title}`} className={'flex flex-col gap-2'}>
              <span className={'color-primary'}>{title}</span>
              <span>{value}</span>
            </div>
          ))}
        </div>

        {(!!extraUser?.user) && (
          <div className={'flex flex-col gap-6'}>

            <div className={'separator'} />

            <Button priority={'tertiary no outline'} onClick={() => setOpenExtra(s => !s)}>
              {(openExtra) ? extraUser.closeLabel : extraUser.openLabel}
            </Button>

            {(openExtra) && (
              <div className={'mt-4 grid grid-cols-3 gap-4'}>
                {extraContents.map(({ title, value }, index) => (
                  <div key={`${index}-${title}`} className={'flex flex-col gap-2'}>
                    <span className={'color-primary'}>{title}</span>
                    <span>{value}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </Panel>
  );
};

interface OfaUserPanelProps {
  title: string;
  user: UtilisateurDto;
  dateHabilitation?: DateISO;
  displayJobAndDates?: boolean;
  extraUser?: {
    user?: UtilisateurDto,
    openLabel: string;
    closeLabel: string;
  };
  onEdit: () => void;
  isFc?: boolean; // boolean pour dire si on se trouve coté fc ou non
}

interface Content {
  title: string;
  value: ReactNode | undefined;
}